// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SoftwareDeNominaParaConstruccionRouteImport } from './routes/software-de-nomina-para-construccion'
import { Route as SoftwareDeGestionDeConstruccionRouteImport } from './routes/software-de-gestion-de-construccion'
import { Route as SoftwareDeGestaoParaConstrucaoRouteImport } from './routes/software-de-gestao-para-construcao'
import { Route as SoftwareDeFolhaDePagamentoParaConstrucaoRouteImport } from './routes/software-de-folha-de-pagamento-para-construcao'
import { Route as SoftwareDeControleDePontoParaConstrucaoRouteImport } from './routes/software-de-controle-de-ponto-para-construcao'
import { Route as SoftwareDeControlHorarioParaConstruccionRouteImport } from './routes/software-de-control-horario-para-construccion'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ConstructionWorkforceManagementSoftwareRouteImport } from './routes/construction-workforce-management-software'
import { Route as ConstructionTimeTrackingSoftwareRouteImport } from './routes/construction-time-tracking-software'
import { Route as ConstructionPayrollSoftwareRouteImport } from './routes/construction-payroll-software'
import { Route as ConstructionManagementSoftwareRouteImport } from './routes/construction-management-software'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkerIntakeTokenRouteImport } from './routes/worker-intake.$token'
import { Route as ClockDemoRouteImport } from './routes/clock.demo'
import { Route as ClockTokenRouteImport } from './routes/clock.$token'
import { Route as AppTeamRouteImport } from './routes/_app.team'
import { Route as AppSupportRouteImport } from './routes/_app.support'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppReportsRouteImport } from './routes/_app.reports'
import { Route as AppPlansRouteImport } from './routes/_app.plans'
import { Route as AppHelpRouteImport } from './routes/_app.help'
import { Route as AppGpsAnalyticsRouteImport } from './routes/_app.gps-analytics'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppClientsRouteImport } from './routes/_app.clients'
import { Route as AppCashFlowRouteImport } from './routes/_app.cash-flow'
import { Route as InvoicesApproveTokenRouteImport } from './routes/invoices.approve.$token'
import { Route as EstimatesApproveTokenRouteImport } from './routes/estimates.approve.$token'
import { Route as ContractsApproveTokenRouteImport } from './routes/contracts.approve.$token'
import { Route as ClientsInviteTokenRouteImport } from './routes/clients.invite.$token'
import { Route as ChangeOrdersApproveTokenRouteImport } from './routes/change-orders.approve.$token'
import { Route as AppTimeTrackingIndexRouteImport } from './routes/_app.time-tracking.index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app.projects.index'
import { Route as AppPayrollIndexRouteImport } from './routes/_app.payroll.index'
import { Route as AppMaterialsIndexRouteImport } from './routes/_app.materials.index'
import { Route as AppJobSitesIndexRouteImport } from './routes/_app.job-sites.index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app.invoices.index'
import { Route as AppExpensesIndexRouteImport } from './routes/_app.expenses.index'
import { Route as AppEstimatesIndexRouteImport } from './routes/_app.estimates.index'
import { Route as AppContractsIndexRouteImport } from './routes/_app.contracts.index'
import { Route as AppChangeOrdersIndexRouteImport } from './routes/_app.change-orders.index'
import { Route as AppProjectsNewRouteImport } from './routes/_app.projects.new'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app.projects.$projectId'
import { Route as AppPayrollTaxFormsRouteImport } from './routes/_app.payroll.tax-forms'
import { Route as AppPayrollNewRouteImport } from './routes/_app.payroll.new'
import { Route as AppPayrollMyPaystubsRouteImport } from './routes/_app.payroll.my-paystubs'
import { Route as AppPayrollRunIdRouteImport } from './routes/_app.payroll.$runId'
import { Route as AppJobSitesJobSiteIdRouteImport } from './routes/_app.job-sites.$jobSiteId'
import { Route as AppInvoicesNewRouteImport } from './routes/_app.invoices.new'
import { Route as AppInvoicesInvoiceIdRouteImport } from './routes/_app.invoices.$invoiceId'
import { Route as AppExpensesNewRouteImport } from './routes/_app.expenses.new'
import { Route as AppExpensesExpenseIdRouteImport } from './routes/_app.expenses.$expenseId'
import { Route as AppEstimatesNewRouteImport } from './routes/_app.estimates.new'
import { Route as AppEstimatesEstimateIdRouteImport } from './routes/_app.estimates.$estimateId'
import { Route as AppContractsNewRouteImport } from './routes/_app.contracts.new'
import { Route as AppContractsContractIdRouteImport } from './routes/_app.contracts.$contractId'
import { Route as AppChangeOrdersNewRouteImport } from './routes/_app.change-orders.new'
import { Route as AppChangeOrdersChangeOrderIdRouteImport } from './routes/_app.change-orders.$changeOrderId'
import { Route as AppAdminSupportRouteImport } from './routes/_app.admin.support'
import { Route as AppAdminMarketingRouteImport } from './routes/_app.admin.marketing'
import { Route as AppAdminEmailAlertsRouteImport } from './routes/_app.admin.email-alerts'
import { Route as AppAdminAdsRouteImport } from './routes/_app.admin.ads'
import { Route as AppAdminAccountsRouteImport } from './routes/_app.admin.accounts'
import { Route as AppReportsIndexRouteImport } from './routes/_app.reports.index'
import { Route as AppReportsProjectsRouteImport } from './routes/_app.reports.projects'
import { Route as AppReportsPayrollRouteImport } from './routes/_app.reports.payroll'
import { Route as AppReportsGpsRouteImport } from './routes/_app.reports.gps'
import { Route as AppReportsFinancialRouteImport } from './routes/_app.reports.financial'
import { Route as ClientsInviteConfirmTokenRouteImport } from './routes/clients.invite.confirm.$token'
import { Route as AppPayrollConfirmItemIdRouteImport } from './routes/_app.payroll.confirm.$itemId'

const UpgradeRoute = UpgradeRouteImport.update({
            id: '/upgrade',path: '/upgrade',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SoftwareDeNominaParaConstruccionRoute = SoftwareDeNominaParaConstruccionRouteImport.update({
            id: '/software-de-nomina-para-construccion',path: '/software-de-nomina-para-construccion',getParentRoute: () => rootRouteImport
          })
const SoftwareDeGestionDeConstruccionRoute = SoftwareDeGestionDeConstruccionRouteImport.update({
            id: '/software-de-gestion-de-construccion',path: '/software-de-gestion-de-construccion',getParentRoute: () => rootRouteImport
          })
const SoftwareDeGestaoParaConstrucaoRoute = SoftwareDeGestaoParaConstrucaoRouteImport.update({
            id: '/software-de-gestao-para-construcao',path: '/software-de-gestao-para-construcao',getParentRoute: () => rootRouteImport
          })
const SoftwareDeFolhaDePagamentoParaConstrucaoRoute = SoftwareDeFolhaDePagamentoParaConstrucaoRouteImport.update({
            id: '/software-de-folha-de-pagamento-para-construcao',path: '/software-de-folha-de-pagamento-para-construcao',getParentRoute: () => rootRouteImport
          })
const SoftwareDeControleDePontoParaConstrucaoRoute = SoftwareDeControleDePontoParaConstrucaoRouteImport.update({
            id: '/software-de-controle-de-ponto-para-construcao',path: '/software-de-controle-de-ponto-para-construcao',getParentRoute: () => rootRouteImport
          })
const SoftwareDeControlHorarioParaConstruccionRoute = SoftwareDeControlHorarioParaConstruccionRouteImport.update({
            id: '/software-de-control-horario-para-construccion',path: '/software-de-control-horario-para-construccion',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ConstructionWorkforceManagementSoftwareRoute = ConstructionWorkforceManagementSoftwareRouteImport.update({
            id: '/construction-workforce-management-software',path: '/construction-workforce-management-software',getParentRoute: () => rootRouteImport
          })
const ConstructionTimeTrackingSoftwareRoute = ConstructionTimeTrackingSoftwareRouteImport.update({
            id: '/construction-time-tracking-software',path: '/construction-time-tracking-software',getParentRoute: () => rootRouteImport
          })
const ConstructionPayrollSoftwareRoute = ConstructionPayrollSoftwareRouteImport.update({
            id: '/construction-payroll-software',path: '/construction-payroll-software',getParentRoute: () => rootRouteImport
          })
const ConstructionManagementSoftwareRoute = ConstructionManagementSoftwareRouteImport.update({
            id: '/construction-management-software',path: '/construction-management-software',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WorkerIntakeTokenRoute = WorkerIntakeTokenRouteImport.update({
            id: '/worker-intake/$token',path: '/worker-intake/$token',getParentRoute: () => rootRouteImport
          })
const ClockDemoRoute = ClockDemoRouteImport.update({
            id: '/clock/demo',path: '/clock/demo',getParentRoute: () => rootRouteImport
          })
const ClockTokenRoute = ClockTokenRouteImport.update({
            id: '/clock/$token',path: '/clock/$token',getParentRoute: () => rootRouteImport
          })
const AppTeamRoute = AppTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AppRoute
          })
const AppSupportRoute = AppSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppReportsRoute = AppReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AppRoute
          })
const AppPlansRoute = AppPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AppRoute
          })
const AppHelpRoute = AppHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => AppRoute
          })
const AppGpsAnalyticsRoute = AppGpsAnalyticsRouteImport.update({
            id: '/gps-analytics',path: '/gps-analytics',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppClientsRoute = AppClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AppRoute
          })
const AppCashFlowRoute = AppCashFlowRouteImport.update({
            id: '/cash-flow',path: '/cash-flow',getParentRoute: () => AppRoute
          })
const InvoicesApproveTokenRoute = InvoicesApproveTokenRouteImport.update({
            id: '/invoices/approve/$token',path: '/invoices/approve/$token',getParentRoute: () => rootRouteImport
          })
const EstimatesApproveTokenRoute = EstimatesApproveTokenRouteImport.update({
            id: '/estimates/approve/$token',path: '/estimates/approve/$token',getParentRoute: () => rootRouteImport
          })
const ContractsApproveTokenRoute = ContractsApproveTokenRouteImport.update({
            id: '/contracts/approve/$token',path: '/contracts/approve/$token',getParentRoute: () => rootRouteImport
          })
const ClientsInviteTokenRoute = ClientsInviteTokenRouteImport.update({
            id: '/clients/invite/$token',path: '/clients/invite/$token',getParentRoute: () => rootRouteImport
          })
const ChangeOrdersApproveTokenRoute = ChangeOrdersApproveTokenRouteImport.update({
            id: '/change-orders/approve/$token',path: '/change-orders/approve/$token',getParentRoute: () => rootRouteImport
          })
const AppTimeTrackingIndexRoute = AppTimeTrackingIndexRouteImport.update({
            id: '/time-tracking/',path: '/time-tracking/',getParentRoute: () => AppRoute
          })
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AppRoute
          })
const AppPayrollIndexRoute = AppPayrollIndexRouteImport.update({
            id: '/payroll/',path: '/payroll/',getParentRoute: () => AppRoute
          })
const AppMaterialsIndexRoute = AppMaterialsIndexRouteImport.update({
            id: '/materials/',path: '/materials/',getParentRoute: () => AppRoute
          })
const AppJobSitesIndexRoute = AppJobSitesIndexRouteImport.update({
            id: '/job-sites/',path: '/job-sites/',getParentRoute: () => AppRoute
          })
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
            id: '/invoices/',path: '/invoices/',getParentRoute: () => AppRoute
          })
const AppExpensesIndexRoute = AppExpensesIndexRouteImport.update({
            id: '/expenses/',path: '/expenses/',getParentRoute: () => AppRoute
          })
const AppEstimatesIndexRoute = AppEstimatesIndexRouteImport.update({
            id: '/estimates/',path: '/estimates/',getParentRoute: () => AppRoute
          })
const AppContractsIndexRoute = AppContractsIndexRouteImport.update({
            id: '/contracts/',path: '/contracts/',getParentRoute: () => AppRoute
          })
const AppChangeOrdersIndexRoute = AppChangeOrdersIndexRouteImport.update({
            id: '/change-orders/',path: '/change-orders/',getParentRoute: () => AppRoute
          })
const AppProjectsNewRoute = AppProjectsNewRouteImport.update({
            id: '/projects/new',path: '/projects/new',getParentRoute: () => AppRoute
          })
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AppRoute
          })
const AppPayrollTaxFormsRoute = AppPayrollTaxFormsRouteImport.update({
            id: '/payroll/tax-forms',path: '/payroll/tax-forms',getParentRoute: () => AppRoute
          })
const AppPayrollNewRoute = AppPayrollNewRouteImport.update({
            id: '/payroll/new',path: '/payroll/new',getParentRoute: () => AppRoute
          })
const AppPayrollMyPaystubsRoute = AppPayrollMyPaystubsRouteImport.update({
            id: '/payroll/my-paystubs',path: '/payroll/my-paystubs',getParentRoute: () => AppRoute
          })
const AppPayrollRunIdRoute = AppPayrollRunIdRouteImport.update({
            id: '/payroll/$runId',path: '/payroll/$runId',getParentRoute: () => AppRoute
          })
const AppJobSitesJobSiteIdRoute = AppJobSitesJobSiteIdRouteImport.update({
            id: '/job-sites/$jobSiteId',path: '/job-sites/$jobSiteId',getParentRoute: () => AppRoute
          })
const AppInvoicesNewRoute = AppInvoicesNewRouteImport.update({
            id: '/invoices/new',path: '/invoices/new',getParentRoute: () => AppRoute
          })
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
            id: '/invoices/$invoiceId',path: '/invoices/$invoiceId',getParentRoute: () => AppRoute
          })
const AppExpensesNewRoute = AppExpensesNewRouteImport.update({
            id: '/expenses/new',path: '/expenses/new',getParentRoute: () => AppRoute
          })
const AppExpensesExpenseIdRoute = AppExpensesExpenseIdRouteImport.update({
            id: '/expenses/$expenseId',path: '/expenses/$expenseId',getParentRoute: () => AppRoute
          })
const AppEstimatesNewRoute = AppEstimatesNewRouteImport.update({
            id: '/estimates/new',path: '/estimates/new',getParentRoute: () => AppRoute
          })
const AppEstimatesEstimateIdRoute = AppEstimatesEstimateIdRouteImport.update({
            id: '/estimates/$estimateId',path: '/estimates/$estimateId',getParentRoute: () => AppRoute
          })
const AppContractsNewRoute = AppContractsNewRouteImport.update({
            id: '/contracts/new',path: '/contracts/new',getParentRoute: () => AppRoute
          })
const AppContractsContractIdRoute = AppContractsContractIdRouteImport.update({
            id: '/contracts/$contractId',path: '/contracts/$contractId',getParentRoute: () => AppRoute
          })
const AppChangeOrdersNewRoute = AppChangeOrdersNewRouteImport.update({
            id: '/change-orders/new',path: '/change-orders/new',getParentRoute: () => AppRoute
          })
const AppChangeOrdersChangeOrderIdRoute = AppChangeOrdersChangeOrderIdRouteImport.update({
            id: '/change-orders/$changeOrderId',path: '/change-orders/$changeOrderId',getParentRoute: () => AppRoute
          })
const AppAdminSupportRoute = AppAdminSupportRouteImport.update({
            id: '/admin/support',path: '/admin/support',getParentRoute: () => AppRoute
          })
const AppAdminMarketingRoute = AppAdminMarketingRouteImport.update({
            id: '/admin/marketing',path: '/admin/marketing',getParentRoute: () => AppRoute
          })
const AppAdminEmailAlertsRoute = AppAdminEmailAlertsRouteImport.update({
            id: '/admin/email-alerts',path: '/admin/email-alerts',getParentRoute: () => AppRoute
          })
const AppAdminAdsRoute = AppAdminAdsRouteImport.update({
            id: '/admin/ads',path: '/admin/ads',getParentRoute: () => AppRoute
          })
const AppAdminAccountsRoute = AppAdminAccountsRouteImport.update({
            id: '/admin/accounts',path: '/admin/accounts',getParentRoute: () => AppRoute
          })
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppReportsRoute
          })
const AppReportsProjectsRoute = AppReportsProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AppReportsRoute
          })
const AppReportsPayrollRoute = AppReportsPayrollRouteImport.update({
            id: '/payroll',path: '/payroll',getParentRoute: () => AppReportsRoute
          })
const AppReportsGpsRoute = AppReportsGpsRouteImport.update({
            id: '/gps',path: '/gps',getParentRoute: () => AppReportsRoute
          })
const AppReportsFinancialRoute = AppReportsFinancialRouteImport.update({
            id: '/financial',path: '/financial',getParentRoute: () => AppReportsRoute
          })
const ClientsInviteConfirmTokenRoute = ClientsInviteConfirmTokenRouteImport.update({
            id: '/clients/invite/confirm/$token',path: '/clients/invite/confirm/$token',getParentRoute: () => rootRouteImport
          })
const AppPayrollConfirmItemIdRoute = AppPayrollConfirmItemIdRouteImport.update({
            id: '/payroll/confirm/$itemId',path: '/payroll/confirm/$itemId',getParentRoute: () => AppRoute
          })





const AppReportsRouteChildren = {
  AppReportsFinancialRoute: AppReportsFinancialRoute,AppReportsGpsRoute: AppReportsGpsRoute,AppReportsPayrollRoute: AppReportsPayrollRoute,AppReportsProjectsRoute: AppReportsProjectsRoute,AppReportsIndexRoute: AppReportsIndexRoute
}

const AppReportsRouteWithChildren = AppReportsRoute._addFileChildren(AppReportsRouteChildren)



const AppRouteChildren = {
  AppCashFlowRoute: AppCashFlowRoute,AppClientsRoute: AppClientsRoute,AppDashboardRoute: AppDashboardRoute,AppGpsAnalyticsRoute: AppGpsAnalyticsRoute,AppHelpRoute: AppHelpRoute,AppPlansRoute: AppPlansRoute,AppReportsRoute: AppReportsRouteWithChildren,AppSettingsRoute: AppSettingsRoute,AppSupportRoute: AppSupportRoute,AppTeamRoute: AppTeamRoute,AppAdminAccountsRoute: AppAdminAccountsRoute,AppAdminAdsRoute: AppAdminAdsRoute,AppAdminEmailAlertsRoute: AppAdminEmailAlertsRoute,AppAdminMarketingRoute: AppAdminMarketingRoute,AppAdminSupportRoute: AppAdminSupportRoute,AppChangeOrdersChangeOrderIdRoute: AppChangeOrdersChangeOrderIdRoute,AppChangeOrdersNewRoute: AppChangeOrdersNewRoute,AppContractsContractIdRoute: AppContractsContractIdRoute,AppContractsNewRoute: AppContractsNewRoute,AppEstimatesEstimateIdRoute: AppEstimatesEstimateIdRoute,AppEstimatesNewRoute: AppEstimatesNewRoute,AppExpensesExpenseIdRoute: AppExpensesExpenseIdRoute,AppExpensesNewRoute: AppExpensesNewRoute,AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,AppInvoicesNewRoute: AppInvoicesNewRoute,AppJobSitesJobSiteIdRoute: AppJobSitesJobSiteIdRoute,AppPayrollRunIdRoute: AppPayrollRunIdRoute,AppPayrollMyPaystubsRoute: AppPayrollMyPaystubsRoute,AppPayrollNewRoute: AppPayrollNewRoute,AppPayrollTaxFormsRoute: AppPayrollTaxFormsRoute,AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,AppProjectsNewRoute: AppProjectsNewRoute,AppChangeOrdersIndexRoute: AppChangeOrdersIndexRoute,AppContractsIndexRoute: AppContractsIndexRoute,AppEstimatesIndexRoute: AppEstimatesIndexRoute,AppExpensesIndexRoute: AppExpensesIndexRoute,AppInvoicesIndexRoute: AppInvoicesIndexRoute,AppJobSitesIndexRoute: AppJobSitesIndexRoute,AppMaterialsIndexRoute: AppMaterialsIndexRoute,AppPayrollIndexRoute: AppPayrollIndexRoute,AppProjectsIndexRoute: AppProjectsIndexRoute,AppTimeTrackingIndexRoute: AppTimeTrackingIndexRoute,AppPayrollConfirmItemIdRoute: AppPayrollConfirmItemIdRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthRoute: AuthRoute,ConstructionManagementSoftwareRoute: ConstructionManagementSoftwareRoute,ConstructionPayrollSoftwareRoute: ConstructionPayrollSoftwareRoute,ConstructionTimeTrackingSoftwareRoute: ConstructionTimeTrackingSoftwareRoute,ConstructionWorkforceManagementSoftwareRoute: ConstructionWorkforceManagementSoftwareRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,ResetPasswordRoute: ResetPasswordRoute,SoftwareDeControlHorarioParaConstruccionRoute: SoftwareDeControlHorarioParaConstruccionRoute,SoftwareDeControleDePontoParaConstrucaoRoute: SoftwareDeControleDePontoParaConstrucaoRoute,SoftwareDeFolhaDePagamentoParaConstrucaoRoute: SoftwareDeFolhaDePagamentoParaConstrucaoRoute,SoftwareDeGestaoParaConstrucaoRoute: SoftwareDeGestaoParaConstrucaoRoute,SoftwareDeGestionDeConstruccionRoute: SoftwareDeGestionDeConstruccionRoute,SoftwareDeNominaParaConstruccionRoute: SoftwareDeNominaParaConstruccionRoute,TermsRoute: TermsRoute,UpgradeRoute: UpgradeRoute,ClockTokenRoute: ClockTokenRoute,ClockDemoRoute: ClockDemoRoute,WorkerIntakeTokenRoute: WorkerIntakeTokenRoute,ChangeOrdersApproveTokenRoute: ChangeOrdersApproveTokenRoute,ClientsInviteTokenRoute: ClientsInviteTokenRoute,ContractsApproveTokenRoute: ContractsApproveTokenRoute,EstimatesApproveTokenRoute: EstimatesApproveTokenRoute,InvoicesApproveTokenRoute: InvoicesApproveTokenRoute,ClientsInviteConfirmTokenRoute: ClientsInviteConfirmTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)